module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f4f66f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gengduoliwu/gengduoliwu.vue
// module id = 989
// module chunks = 1